import { BrandCode, brandMap } from '../../const/brandMap';
import { registriaHosts } from '../../const/registriaHosts';
/**
 * @description Based on the brand and environment that is passed in, this function will return the appropriate base URL for the Registria redirect
 * @returns {string | undefined} A string representing the base URL for the Registria redirect, or undefined if the brand is not recognized
 *
 * @example
 * const registriaUrl = getRegistriaUrl('whirl', 'production');
 * console.log(registriaUrl); // Output: 'https://whirlpool.registria.com'
 *
 * const registriaUrlQA = getRegistriaUrl('amana', 'qa');
 * console.log(registriaUrlQA); // Output: 'https://amana.registriaqa.com'
 *
 * const registriaUrlInvalidBrand = getRegistriaUrl('unknownBrand', 'production');
 * console.log(registriaUrlInvalidBrand); // Output: undefined
 *
 * const registriaUrlInvalidEnv = getRegistriaUrl('whirl', 'unknownEnv');
 * console.log(registriaUrlInvalidEnv); // Output: 'https://whirlpool.registriaqa.com' (defaults to development environment)
 */
export const getRegistriaUrl = (brand: string, environment: string): string | undefined => {
  let env = 'development' as keyof typeof registriaHosts;

  const key = brand.toLocaleLowerCase() as BrandCode;
  const brandName = brandMap[key];

  if (['production', 'qa', 'development', 'sandbox'].includes(environment)) {
    env = environment as keyof typeof registriaHosts;
  }

  return brandName ? `https://${brandName}.${registriaHosts[env]}` : undefined;
};
